module.exports = __webpack_public_path__ + "img/dashboard.830c44cc.svg";